import { MasterVM } from "./MasterVM";

export class ResourceConfigurationDto {
    ResViewManagerialCountries :MasterVM[];
    // ResViewLegalEntities :MasterVM[];
    // ResViewBusinessUnits:MasterVM[];
    // ResViewOperatingUnits :MasterVM[];
    // ResViewManagementUnits :MasterVM[]
    // ResViewSubManageUnits :MasterVM[];
    ResViewCompanyCodes:MasterVM[];
    ResViewEconomicLocations:MasterVM[];
    ResViewCompetencies:MasterVM[];

    ResViewOfficeLocations :MasterVM[];
    ResViewServiceLines:MasterVM[];
    ResViewSubServiceLines :MasterVM[];
    ResViewRanks :MasterVM[];
    ActivityType :MasterVM[];
    ResViewDepartments : MasterVM[];
    ResViewResourceCostCenters: MasterVM[];
    ResViewGDSRegionAlignments : MasterVM[];
    ResViewActivityTypes :MasterVM[];
}

export class JobConfigurationDto {
    JobViewManagerialCountries :MasterVM[];
    //JobViewBusinessUnits :MasterVM[];
    //ManagementUnits :MasterVM[];
    //OperatingUnits :MasterVM[];
    //JobViewLegalEntities:MasterVM[];
    //JobViewSubManageUnits :MasterVM[]
    JobViewCompanyCodes: MasterVM[];
    JobViewEconomicLocations: MasterVM[];
    JobViewCompetencies: MasterVM[];

    JobViewServiceLines :MasterVM[];
    JobViewSubServiceLines:MasterVM[];
    JobViewJobCategories:MasterVM[];
    JobViewJobTypes :MasterVM[];
}

export class ConfigureVM {
    UA_Comments: string;
    UA_CreatedBy: number;
    UA_CreatedDate : string
    UA_ID: number;
    UA_J_Link: boolean;
    UA_ModifiedBy: number;
    UA_ModifiedDate: string;
    UA_Name: string;
    UA_R_Link: boolean;
    UA_U_UserId: number;
    userApproverJobConfigurationDto: JobConfigurationDto;
    userApproverResConfigurationDto:ResourceConfigurationDto;
    Message : string;
}